import ManualSolve from "./Manual";
import Rules from "./Rules";
import Navigation from "./Navigation";

const PageManual = () => {
  return (
    <div className="bg-blue w-full min-w-full min-h-screen font-primary">
      <div className="container">
        <Navigation />
        <main className="w-full">
          <div className="flex flex-col">
            <Rules />        
            <ManualSolve />
          </div>
        </main>
      </div>
    </div>
  );
}
export default PageManual;